<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ page.title }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">{{ page.desc }}</p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <!-- ONT列表状态信息 -->
        <block-cntr :btitle="page.blkTitle.ontStatusTable" style="height: 100%">
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div @click="loadontlist" class="btn" :class="{}" style="padding: 0px">
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <!-- ONT List 表 -->
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th v-for="(value, key) in ontListTable.title" :key="key" :title="value">{{value}}</th>
              </tr>
            </thead>
            <tbody style="height: 500px">
              <tr v-for="row in ontListTable.data" :key="row.ontid">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div
                    v-if="key === 'status'"
                    class="fa fa-circle"
                    :style="{
                      color: row.status === 'online' ? '#32CD32' : '#FF4500',
                    }"
                  ></div>
                  <div v-else>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>

    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "portStatus",
  components: {
    BlockCntr,
  },
  data() {
    return {
      page: en.page.ontstatus,
      ontListTable: "",
    }
  },
  created() {
      this.loadontlist()
  },
  methods: {
    loadontlist(){
        get("ontlist")
        .then((res) => (this.ontListTable = res.data))
        .catch((err) => {
            this.ontListTable = en.ontListTable
        })
    },
  }
}
</script>